import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';

const Promo = ({ headline, description, cta, ctaBgLight = false }) => {
	return (
		<div className="promo section">
			<div className="section__content">
				<h2 className="typography typography--h2 typography--secondary">
					{headline}
				</h2>
				<p className="typography typography--subtle-big typography--secondary">
					{description?.description}
				</p>
				{cta?.title && (
					<Link to={cta.link} className={`btn ${ctaBgLight ? 'btn--outlined' :'btn--secondary'}`}>
						{cta.title}
					</Link>
				)}
			</div>
		</div>
	);
};

Promo.propTypes = {
	headline: PropTypes.string.isRequired,
	description: PropTypes.shape({ description: PropTypes.string.isRequired }),
	cta: PropTypes.shape({
		title: PropTypes.string,
		link: PropTypes.string,
	}),
	ctaBgLight: PropTypes.boolean
};

export default Promo;
